<template>
    <div ref="editorform" class="ace-editor"></div>
</template>

<script setup>
import { watch, onMounted, onBeforeUnmount, ref, toRefs } from "vue";
import "@/assets/ace/ace"
import "@/assets/ace/theme-xcode"
import "@/assets/ace/ext-inline_autocomplete"
import "@/assets/ace/ext-beautify"
import "@/assets/ace/mode-json"
import "@/assets/ace/snippets/json"
import "@/assets/ace/mode-javascript"
import "@/assets/ace/snippets/javascript"
// import "@/assets/ace/ext-language_tools"

// 格式化代码
const beautify = ace.require("ace/ext/beautify");
// ace加载实例
let editor = null
const editorform = ref(null);

const props = defineProps({
    modelValue: String,
    mode: String,
})
const { modelValue, mode } = toRefs(props)
const emits = defineEmits(["update:modelValue"]);

watch(
    () => modelValue.value,
    (newVal) => {
        //解决光标移动问题
        const position = editor.getCursorPosition();
        editor.getSession().setValue(newVal);
        editor.clearSelection();
        editor.moveCursorToPosition(position);
    }
);
onMounted(() => {
    initEditor();
});
onBeforeUnmount(() => {
    editor.destroy();
});

// 实例初始化
const initEditor = () => {
    if (editor) {
        //实例销毁
        editor.destroy();
    }
    //初始化
    editor = ace.edit(editorform.value);
    // 使用xcode主题
    editor.setTheme("ace/theme/xcode");
    editor.getSession().setMode(`ace/mode/${mode.value}`);

    //自定义代码提示
    // let _comp_cfg = [{
    //     name: "forEach", //显示的名称，‘奖金’
    //     value: "forEach((v,k)=>{})", //插入的值，‘100’
    //     caption:"fe",//这才是关键字
    //     score: 100, //分数，越大的排在越上面
    //     meta: "遍历" //描述，‘我的常量
    // }]

    // ace.config.loadModule("ace/ext/language_tools", function (module) {
    //     module.addCompleter({
    //         getCompletions: function (editor, session, pos, prefix, callback) {
    //             if (prefix.length === 0) { callback(null, []); return }
    //             callback(null, _comp_cfg);
    //         }
    //     });
    // });

    editor.setOptions({
        useWorker: false,
        // 只读
        // readOnly: true,
        // 启用滚动
        autoScrollEditorIntoView: true,
        // 启用换行
        wrap: true,
        fontSize: '15px',
        // 启用自动滚动到底部  0, 0.5, and 1
        scrollPastEnd: 0,
        // 显示参考线
        displayIndentGuides: false,
        // 代码提示和自动补全
        enableSnippets: true,
        enableLiveAutocompletion: true,
        enableBasicAutocompletion: true,
    })
    // 支持双向绑定
    editor.on("change", () => {
        emits("update:modelValue", editor.getValue());
    });
    //快捷键
    editor.commands.addCommand({
        name: 'formatter',
        bindKey: { win: 'Ctrl-Shift-F', mac: 'Command-Shift-F' },
        exec: () => beautify.beautify(editor.session),
    })
    if (mode.value == "json") {
        editor.setValue(JSON.stringify(modelValue.value ? JSON.parse(modelValue.value) : "", null, '\t'))
    } else if (mode.value == "javascript") {
        editor.setValue(modelValue.value ? modelValue.value : "")
    }


}
</script>
<style lang="scss" scoped>
.ace-chaos .ace_meta.ace_tag {
    color: #53a7e6 !important;
}

.ace-chaos .ace_string {
    color: #c58854 !important;
}

.ace-chaos .ace_keyword {
    color: #e0e0e0 !important;
}

.ace-chaos .ace_constant.ace_numeric {
    color: #c5c454 !important;
}
</style>
  